/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Outreach_Updatedatapoints3Inputs */

const en_coinvestments_outreach_updatedatapoints3 = /** @type {(inputs: Coinvestments_Outreach_Updatedatapoints3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Salesforce Data`)
};

/**
* | output |
* | --- |
* | "Update Salesforce Data" |
*
* @param {Coinvestments_Outreach_Updatedatapoints3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_outreach_updatedatapoints3 = /** @type {((inputs?: Coinvestments_Outreach_Updatedatapoints3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Outreach_Updatedatapoints3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_outreach_updatedatapoints3(inputs)
});
export { coinvestments_outreach_updatedatapoints3 as "coInvestments_outreach_updateDataPoints" }